import React, { createContext, useContext } from 'react';
import { jwtDecode } from 'jwt-decode';
import { fetchToken } from '../utils/cookie';
import { UserAttributes } from '../pages/AccountManagementPage';

const DecodedIdTokenContext = createContext<UserAttributes | null>(null);

export const useDecodedIdToken = () => useContext(DecodedIdTokenContext);

export const DecodedIdTokenProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const token = fetchToken('idToken');
  let decoded: UserAttributes | null = null;

  try {
    if (token) {
      decoded = jwtDecode<UserAttributes>(token);
    }
  } catch (err) {
    console.error('Failed to decode token', err);
  }

  return (
    <DecodedIdTokenContext.Provider value={decoded}>
      {children}
    </DecodedIdTokenContext.Provider>
  );
};
